import { APIRepository } from "~/context/Shared/infrastructure/APIRepository";
import { vectiAppApiUrl } from "~/context/Shared/infrastructure/Config";
import { DocumentDataRepository } from "../domain/DocumentDataRepository";
import { DocumentSumReconciliationByYearMonth } from "../domain/DocumentSumReconciliationByYearMonth";
import { DocumentSumReconciliation } from "../domain/DocumentSumReconciliation";
import { DocumentSumReconciliationByYear } from "../domain/DocumentSumReconciliationByYear";
import { InvoiceIncomeOutcomeSumFutureByRange } from "~/context/InvoicesData/domain/InvoiceIncomeOutcomeSumFutureByRange";

export function createApiDocumentDataRepository(): DocumentDataRepository {
  return new ApiDocumentDataRepository();
}

export class ApiDocumentDataRepository extends APIRepository implements DocumentDataRepository {
  constructor() {
    super(vectiAppApiUrl());
  }


  listResumeReconciliationDocumentsYearMonth(companyUid: string): Promise<DocumentSumReconciliationByYearMonth[]>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<DocumentSumReconciliationByYearMonth[]>("/api/documentsdata/company/" + companyUid.toString() + "/resumeDocumentsReconciliationByYearMonth" );
    }
  }

  listResumeReconciliationDocumentsYear(companyUid: string): Promise<DocumentSumReconciliationByYear[]>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<DocumentSumReconciliationByYear[]>("/api/documentsdata/company/" + companyUid.toString() + "/resumeDocumentsReconciliationByYear" );
    }
  }

  listResumeReconciliationDocuments(companyUid: string): Promise<DocumentSumReconciliation>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<DocumentSumReconciliation>("/api/documentsdata/company/" + companyUid.toString() + "/resumeDocumentsReconciliation" );
    }
  }

  listSumFutureOutcomeDocumentsRange(companyUid: string): Promise<InvoiceIncomeOutcomeSumFutureByRange[]>{
  if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<InvoiceIncomeOutcomeSumFutureByRange[]>("/api/documentsdata/company/" + companyUid.toString() + "/resumeFutureOutcomeDocumentPerRange" );
    }
  }

  listSumFutureIncomeDocumentsRange(companyUid: string): Promise<InvoiceIncomeOutcomeSumFutureByRange[]>{
  if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<InvoiceIncomeOutcomeSumFutureByRange[]>("/api/documentsdata/company/" + companyUid.toString() + "/resumeFutureIncomeDocumentPerRange" );
    }
  }



}

